import {createContext} from 'react';
const TxnContext = createContext();
export default TxnContext;